import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import useSessionGuard from 'hooks/useSession';
import AuthLoader from 'components/AuthLoader';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  let isAuthenticated = false;
  let isLoading = true;
  
  try {
    const result = useSessionGuard();
    isAuthenticated = result.isLoggedIn ?? false;
    isLoading = !(result.isInitialized ?? false);
  } catch (error) {
    // Fallback values are already set above
  }
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're not loading and are authenticated
    if (!isLoading && isAuthenticated) {
      navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, navigate, location]);

  // Show loading state while checking authentication
  if (isLoading) {
    return <AuthLoader />;
  }

  // Only render children if not authenticated (guest)
  if (isAuthenticated) {
    return null; // This prevents flash - redirect will happen in useEffect
  }

  // Render children only when not authenticated (guest)
  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
